import React, { Component } from 'react';
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FormCreateFiles from "../../../GeneralComponents/FormGeneralFile"

class Index extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            isLoaded: true,
            showSubmitComment: false,
            modeEditComment: false,
            modaFiles: false,

            formComment: {
                comment: "",
                module_name: "Tareas",
                notify: "",
                user_ids: [],
                module_comment_id: this.props.task.module_comment_id,
            },

            formUpdateComment: {
                comment: "",
                user_ids: [],
            },

            id: "",
            module_file_id: "",
            data: [],
        }
    }


    componentDidMount = () => {
        this.loadComments();
    }

    loadComments = () => {
        fetch(`/get_general_commets_indicators/${this.props.task.module_comment_id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    data: data.data,
                    isLoaded: false
                });
            });
    }


    HandleChange = (e) => {
        this.setState({
            formComment: {
                ...this.state.formComment,
                comment: (e.target.value.length + 0 > 500 ? this.state.formComment.comment : e.target.value),
            }
        });
    }

    HandleChangeUpdateComment = (e) => {
        this.setState({
            formUpdateComment: {
                ...this.state.formUpdateComment,
                comment: e.target.value,
            }
        });
    }

    editComment = (comentario) => {
        let arrayUsersEdit = []
        let arrayIds = []

        comentario.users.map((item) => (
            arrayUsersEdit.push({ label: `${item.first_name} ${item.first_last_name}`, value: item.id }),
            arrayIds.push(item.id)
        ))

        this.setState({
            formUpdateComment: {
                ...this.state.formUpdateComment,
                comment: comentario.comment,
                user_ids: arrayIds
            },

            id: comentario.id,
            editValuesUsers: arrayUsersEdit,
            showSubmitComment: false,
            modeEditComment: true,
        })
    }


    deleteComment = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si"
        }).then(result => {
            if (result.value) {
                fetch(`/general_comments/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })

                    .then(response => response.json())
                    .then(response => {
                        this.loadComments();
                        this.props.updateItem(response.task)
                    });
            }
        });
    };

    clearValues = () => {
        this.setState({
            showSubmitComment: false,
            modeEditComment: false,
            editValuesUsers: [],
            formComment: {
                ...this.state.formComment,
                comment: "",
                notify: "",
                user_ids: [],
            }
        })
    }

    updateDataComents = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    updateItemComents = comment => {
        this.setState({
            data: this.state.data.map(item => {
                if (comment.id === item.id) {
                    return {
                        ...item,
                        comment: comment.comment,
                        users: comment.users,
                    }
                }
                return item;
            })
        });
    }

    HandleClickComment = () => {
        if (this.state.id != "") {
            fetch(`/general_comments/${this.state.id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(this.state.formUpdateComment), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })

                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.updateItemComents(data.comment)
                    this.setState({ id: "", modeEditComment: false, editValuesUsers: [] })
                });
        } else {
            fetch(`/general_comments`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(this.state.formComment), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": this.token,
                    "Content-Type": "application/json"
                }
            })

                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    if (this.props.updateItem != undefined) {
                        this.props.updateItem(data.task)
                    }
                    this.updateDataComents(data.comment)
                    this.clearValues();
                });
        }
    }

    getDateTime = (datetime) => {
        let date = new Date(datetime)
        let result = date.getFullYear() + "-" + (date.getMonth() < 10 ? 0 : "") + (date.getMonth() + 1) + "-" + (date.getDate() < 10 ? 0 : "") + date.getDate()
        return result
    }


    addFiles = (comment) => {
        this.setState({
            module_file_id: comment.module_file_id,
            modaFiles: true,
        })
    }


    //files 

    HandleChangeFiles = (e) => {
        this.setState({
            formAddFiles: {
                ...this.state.formAddFiles,
                [e.target.name]: e.target.value
            }
        });
    }


    clearValuesFiles = () => {
        this.setState({
            formAddFiles: {
                ...this.state.formAddFiles,
                fileName: "",
                file: {},
            },

            isLoadedFiles: false,
            nameFile: "",
            file: null
        })
    }

    toogleFiles = (from) => {
        if (from == "new") {
            this.setState({ modaFiles: true })
        } else {
            this.setState({ modaFiles: false })
        }
    }

    HandleChangeCheckBox = (e) => {
        this.setState({
            formComment: {
                ...this.state.formComment,
                notify: e.target.checked,
            }
        });
    }

    render() {
        const options = {

            buttons: {
                iconColor: "rgb(255, 255, 255)",
                showDownloadButton: false,
                showNextButton: false,
                showPrevButton: false,
                showAutoplayButton: false,
            },

            thumbnails: {
                showThumbnails: false,
            },

            caption: {
                captionFontFamily: "Raleway, sans-serif",
                captionFontWeight: "300",
                captionTextTransform: "uppercase",
            }

        };

        return (
            <React.Fragment>
                {this.state.modaFiles && (
                    <FormCreateFiles
                        //modal props
                        delete_file={true}
                        edit_file={true}
                        backdrop={"static"}
                        modal={this.state.modaFiles}
                        toggle={this.toogleFiles}
                        title={"Agregar Archivos"}

                        //form props

                        module_file_id={this.state.module_file_id}
                        formValues={this.state.formAddFiles}
                        onChangeForm={this.HandleChangeFiles}
                        submitForm={this.HandleClickFiles}

                        //table files 

                        dataFiles={this.state.dataUsersFiles}
                        handleFileChange={this.handleFile}

                        //load info

                        loadDataTable={this.loadComments}

                        module_id={"user_id"}
                        idGeneralFile={this.state.idGeneralFile}

                        isLoadedFiles={this.state.isLoadedFiles}

                        nameFile={this.state.nameFile}
                        sizeFile={this.state.sizeFile}
                    />
                )}

                <div className="col-md-12 mt-4">
                    <div className="row">
                        <div className='col-md-1 text-center'>
                            <i
                                className="fas fa-comments"
                                style={{ fontSize: "29px" }}
                            >
                            </i>
                        </div>

                        <div className='col-md-11'>
                            <h4>Seguimientos y/o comentarios</h4>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 mt-4">
                    <div className="row">

                        <div className='col-md-1 text-center'>
                            <img
                                src={this.props.user.avatar} alt=""
                                className="img-user-task"
                            />
                        </div>

                        <div className='col-md-11'>
                            <b>{this.props.user.name}</b>

                            <div className="card">
                                <textarea
                                    type="text"
                                    className="form form-control"
                                    placeholder="Escriba un seguimiento y/o comentario..."
                                    value={this.state.formComment.comment}
                                    onChange={this.HandleChange}
                                    onClick={() => this.setState({ showSubmitComment: true, id: "" })}
                                    rows="4"
                                    style={{ resize: "none" }}
                                >
                                </textarea>
                                <span className="span-count" style={{ color: (this.state.formComment.comment.length + 0 >= 500 ? "red" : "#3f6ad8") }}>
                                    {500 - this.state.formComment.comment.length}
                                </span>
                            </div>

                            {this.state.showSubmitComment && (
                                <React.Fragment>
                                    <div className="col-md-12 text-right pr-0 mt-2">
                                        <div className="custom-control custom-switch">
                                            <input type="checkbox" className="custom-control-input" id={`customShowFilter`} checked={this.state.formComment.notify} onChange={this.HandleChangeCheckBox} />
                                            <label className="custom-control-label" htmlFor={`customShowFilter`}>Notificar a los interesados</label>
                                        </div>
                                    </div>

                                    <button className="btn-shadow btn btn-success mt-3 mr-2" disabled={this.state.formComment.comment.length >= 500 ? true : false} onClick={() => this.HandleClickComment()}>Crear</button>
                                    <button className="btn-shadow btn btn-danger mt-3" onClick={() => this.clearValues()}>Cancelar</button>
                                </React.Fragment>
                            )}

                        </div>

                    </div>
                </div>

                {this.state.data.length >= 1 && (
                    <div className="col-md-12 mt-4">
                        <hr />
                        {this.state.data.map((commentario, index) => (
                            <div key={commentario.id} className={`row ${index >= 1 ? 'mt-3' : ""}`}>
                                <div className='col-md-1 text-center'>
                                    <SimpleReactLightbox>
                                        <SRLWrapper options={options}>
                                            <img
                                                src={commentario.user != null ? commentario.user.avatar : "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcRuEG5mQKFGi9hNgrdBJnEyBfw2Kl0JNXwoHiXjVeKQemKOQqFe"}
                                                alt={file.fileName}
                                                style={{ cursor: "pointer" }}
                                                className="img-user-task"
                                            />
                                        </SRLWrapper>
                                    </SimpleReactLightbox>
                                </div>

                                <div className='col-md-11'>
                                    <b>{commentario.user != null ? commentario.user.first_name : "Usuario"} {commentario.user != null ? commentario.user.first_last_name : ""}</b> <span style={{ color: "gray" }}>({this.getDateTime(commentario.created_at)})</span>
                                    <div className="card">
                                        <div className="card-body" style={{ padding: "10px" }}>
                                            {commentario.id == this.state.id ? (
                                                <React.Fragment>
                                                    <textarea
                                                        type="text"
                                                        className="form form-control"
                                                        placeholder="Escriba un seguimiento y/o comentario..."
                                                        value={this.state.formUpdateComment.comment}
                                                        onChange={this.HandleChangeUpdateComment}
                                                        rows="5"
                                                        style={{ resize: "none" }}
                                                    >
                                                    </textarea>

                                                    {false && (
                                                        <div className="mt-3">
                                                            <input
                                                                type="hidden"
                                                                name="user_ids"
                                                                value={this.state.selectedOptionComment.user_ids}
                                                            />

                                                            <Select
                                                                isMulti
                                                                closeMenuOnSelect={false}
                                                                autoFocus={false}
                                                                className={`link-form`}
                                                                classNamePrefix="select"
                                                                name="user_ids"
                                                                onChange={this.handleChangeAutocompleteMulti}
                                                                options={this.state.users}
                                                                defaultValue={[
                                                                    this.state.editValuesUsers[0],
                                                                    this.state.editValuesUsers[1],
                                                                    this.state.editValuesUsers[2],
                                                                    this.state.editValuesUsers[3],
                                                                    this.state.editValuesUsers[4],
                                                                    this.state.editValuesUsers[5]
                                                                ]}
                                                            />
                                                        </div>
                                                    )}
                                                </React.Fragment>
                                            ) : (
                                                    <p className="mb-0">{commentario.comment}</p>
                                                )}
                                        </div>

                                        {(commentario.id == this.state.id && this.state.id != "") && (
                                            <React.Fragment>
                                                <div className="card-footer">
                                                    <button className="btn-shadow btn btn-success mr-2" onClick={() => this.HandleClickComment()}>Actualizar</button>
                                                    <button className="btn-shadow btn btn-danger" onClick={() => this.setState({ id: "", modeEditComment: false, editValuesUsers: [] })}>Cancelar</button>
                                                </div>
                                            </React.Fragment>
                                        )}

                                    </div>
                                    <div className="row">
                                        {(commentario.user != null ? commentario.user.id : true) == this.props.user.id && (
                                            <div className="col-md-6 mt-2">
                                                <div className="row">
                                                    <div className="col-md-2 text-right">
                                                        <span className="action-comment" onClick={() => this.editComment(commentario)}>Editar</span>
                                                    </div>

                                                    <div className="col-md-2 pr-0">
                                                        <span className="action-comment" onClick={() => this.deleteComment(commentario.id)}>Eliminar</span>
                                                    </div>

                                                </div>
                                            </div>
                                        )}
                                        {commentario.module_file_id != null && (
                                            <div className={(commentario.user != null ? commentario.user.id : true) == this.props.user.id ? "col-md-6 mt-2 text-right" : "col-md-6 mt-2 text-left" }>
                                                <i className="fas fa-paperclip ml-2" style={{ cursor: "pointer" }} onClick={() => this.addFiles(commentario)}></i> <span>{commentario.general_files}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Index;
